import React, { useState } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Header from "./components/Header";
import Footer from "./components/Footer";
import CartDrawer from "./components/CartDrawer";
import FloatingWhatsApp from "./components/FloatingWhatsApp";
import useCart from "./useCart";
import Home from "./pages/Home";
import Shop from "./pages/Shop";
import Gallery from "./pages/Gallery";
import Workshop from "./pages/Workshop";
import News from "./pages/News";
import NewsArticle from "./pages/NewsArticle";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Wishlist from "./pages/Wishlist";
import TrackOrder from "./pages/TrackOrder";
import Awards from "./pages/Awards";
import AdminLogin from "./pages/AdminLogin";
import Admin from "./pages/Admin";
import NotFound from "./pages/NotFound";

function ScrollToTop() {
  const { pathname } = useLocation();
  React.useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

function Shell() {
  const cart = useCart();
  const [cartOpen, setCartOpen] = useState(false);
  const openCart = () => setCartOpen(true);

  return (
    <div className="min-h-screen bg-bone text-ink flex flex-col">
      <Header cartCount={cart.count} onCartOpen={openCart} />
      <main className="flex-1 pt-[120px]">
        <Routes>
          <Route path="/" element={<Home onAdd={cart.add} onBuyNow={openCart} />} />
          <Route path="/shop" element={<Shop onAdd={cart.add} onBuyNow={openCart} />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/workshop" element={<Workshop />} />
          <Route path="/news" element={<News />} />
          <Route path="/news/:slug" element={<NewsArticle />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/wishlist" element={<Wishlist onAdd={cart.add} onBuyNow={openCart} />} />
          <Route path="/track" element={<TrackOrder />} />
          <Route path="/awards" element={<Awards />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
      <CartDrawer
        open={cartOpen}
        onClose={() => setCartOpen(false)}
        cart={cart}
      />
      <FloatingWhatsApp />
      <Toaster
        position="bottom-center"
        toastOptions={{
          style: {
            background: "#1F1B16",
            color: "#F2EDE3",
            border: "1px solid rgba(242,237,227,0.1)",
            fontFamily: "Inter, sans-serif",
            borderRadius: "999px",
            padding: "14px 22px",
          },
        }}
      />
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Shell />
    </BrowserRouter>
  );
}
